module.exports = "/static/assets/49977a0d3680d3a72955df57e5a15afb.svg";